module.exports = __webpack_public_path__ + "img/icon_img07.961d9ceb.png";